export default {
  Title: 'EFT/POS Transactions',

  Table: {
    Toolbar: {
      Button: {
        Receipts: {
          Title: 'Fiscal Documents',
          Icon : 'mdi-receipt-text-outline',
          Color: 'primary'
        },
        Export: {
          Title  : 'Export',
          Icon   : 'file_download',
          Color  : 'primary',
          Success: 'Soon you\'ll receive a file with the exported transactions at the email(s) you selected'
        },
        ResendAll: {
          Title: 'Resend All',
          Icon : 'mdi-invoice-text-send-outline',
          Color: 'primary'
        }
      }
    },

    Button: {
      View: {
        Title: 'View Transaction',
        Icon : 'remove_red_eye',
        Color: 'cyan'
      },

      Refresh: {
        Title: 'Refresh Transaction',
        Icon : 'mdi-cloud-refresh-outline',
        Color: 'light-blue'
      },

      Refund: {
        Title: 'Refund Transaction',
        Icon : 'mdi-credit-card-refund',
        Color: 'purple'
      },

      Delete: {
        Title: 'Delete Transaction',
        Icon : 'delete',
        Color: 'red'
      }
    },

    Headers: {
      Id               : '#',
      TransactionId    : 'Transaction',
      OrderCode        : 'Intent Id',
      Terminal         : 'Terminal',
      Order            : 'Order',
      Amount           : 'Amount',
      TransactionType  : 'Type',
      PaymentType      : 'Payment Type',
      TransactionResult: 'Result',
      TransactionStatus: 'Status',
      Date             : 'Date',
      Actions          : ''
    },

    Filter: {
      filterType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : true,
        Label      : 'Type',
        PlaceHolder: 'All types',
        ItemText   : 'Name',
        ItemValue  : 'Code',
        Items      : []
      },
      filterPaymentType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Payment Type',
        PlaceHolder: 'All payment types',
        ItemText   : 'Name',
        ItemValue  : 'Code',
        Items      : []
      },
      filterStatus: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Status',
        PlaceHolder: 'All statuses',
        ItemText   : 'Name',
        ItemValue  : 'Code',
        Items      : []
      },
      filterResult: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : true,
        Label      : 'Result',
        PlaceHolder: 'All results',
        ItemText   : 'Name',
        ItemValue  : 'Custom',
        Items      : []
      },
      filterTerminal: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Terminal',
        PlaceHolder: 'All terminals',
        ItemText   : 'Name',
        ItemValue  : 'Code',
        Items      : []
      },
      filterTable: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Table',
        PlaceHolder: 'All tables',
        ItemText   : 'Name',
        ItemValue  : 'Code',
        Items      : []
      }
    }
  },

  Dialog: {
    View: {
      Toolbar: {
        Title   : 'Transaction History',
        Subtitle: '',
        Icon    : 'mdi-history'
      }
    },

    ResendAll: {
      Toolbar: {
        Title   : 'EFT/POS Payment Terminals',
        Subtitle: 'Select EFT/POS Payment Terminal',
        Icon    : 'mdi-credit-card-wireless'
      },
      Message: {
        ProcessedTransactions: 'Processed Transactions: {ProcessedTransactions}'
      }
    }
  },

  Transaction: {
    Type: {
      SALE: {
        Id     : 0,
        Code   : 'SALE',
        Name   : 'SALE',
        Tooltip: '',
        Icon   : 'mdi-credit-card-outline',
        Color  : 'teal'
      },
      REFUND: {
        Id     : 1,
        Code   : 'REFUND',
        Name   : 'REFUND',
        Tooltip: '',
        Icon   : 'mdi-credit-card-refund',
        Color  : 'purple'
      },
      EMPTY: {
        Id     : 2,
        Code   : 'EMPTY',
        Name   : 'EMPTY',
        Tooltip: '',
        Icon   : 'mdi-help',
        Color  : 'grey'
      }
    },
    Status: {
      PENDING: {
        Id     : 1,
        Code   : 'PENDING',
        Name   : 'PENDING',
        Tooltip: 'Pending Transaction',
        Icon   : 'mdi-clock-outline',
        Color  : 'blue-grey'
      },
      SENT: {
        Id     : 2,
        Code   : 'SENT',
        Name   : 'SENT',
        Tooltip: 'Sent Transaction',
        Icon   : 'mdi-send-outline',
        Color  : 'light-blue'
      },
      COMPLETED: {
        Id     : 3,
        Code   : 'COMPLETED',
        Name   : 'COMPLETED',
        Tooltip: 'Completed Transaction',
        Icon   : 'mdi-check',
        Color  : 'green'
      }
    },

    Result: {
      APPROVED: {
        Id         : 1,
        Custom     : 'APPROVED',
        Code       : 'APPROVED',
        Name       : 'APPROVED',
        Desc       : 'APPROVED AUTO',
        Tooltip    : 'The transaction has been completed and approved.',
        Type       : 'success',
        Icon       : 'mdi-credit-card-check-outline',
        Color      : 'green',
        ColorAvatar: 'green'
      },
      APPROVED_MANUAL: {
        Id         : 1,
        Custom     : 'USER_APPROVED',
        Code       : 'APPROVED',
        Name       : 'APPROVED',
        Desc       : 'APPROVED MANUAL',
        Tooltip    : 'The transaction has been completed and approved manually by user {user}.',
        Type       : 'success',
        Icon       : 'mdi-account-check',
        Color      : 'green',
        ColorAvatar: 'orange'
      },
      REVERTED_MANUAL: {
        Id         : 1,
        Custom     : 'USER_REVERTED',
        Code       : 'REVERTED',
        Name       : 'REVERTED',
        Desc       : 'REVERTED MANUAL',
        Tooltip    : 'The transaction has been completed and user {user} manual approval has been reverted.',
        Type       : 'success',
        Icon       : 'mdi-account-check',
        Color      : 'blue',
        ColorAvatar: 'orange'
      },
      DECLINED: {
        Id         : 2,
        Custom     : 'DECLINED',
        Code       : 'DECLINED',
        Name       : 'DECLINED',
        Desc       : 'DECLINED',
        Tooltip    : 'The transaction has been completed and declined!',
        Type       : 'error',
        Icon       : 'mdi-credit-card-remove-outline',
        Color      : 'pink',
        ColorAvatar: 'pink'
      },
      CANCELLED: {
        Id         : 3,
        Custom     : 'CANCELLED',
        Code       : 'CANCELLED',
        Name       : 'CANCELLED',
        Desc       : 'CANCELLED',
        Tooltip    : 'The transaction was canceled by the EFT/POS terminal user.',
        Type       : 'warning',
        Icon       : 'mdi-credit-card-off-outline',
        Color      : 'darken-1 amber',
        ColorAvatar: 'darken-1 amber'
      },
      FAILED: {
        Id         : 4,
        Custom     : 'FAILED',
        Code       : 'FAILED',
        Name       : 'FAILED',
        Desc       : 'FAILED',
        Tooltip    : 'The transaction with EFT/POS terminal has failed to complete!',
        Type       : 'error',
        Icon       : 'mdi-close',
        Color      : 'red',
        ColorAvatar: 'red'
      },
      UNKNOWN: {
        Id         : 5,
        Custom     : 'UNKNOWN',
        Code       : 'UNKNOWN',
        Name       : 'UNKNOWN',
        Desc       : 'UNKNOWN',
        Tooltip    : 'The result of the transaction is unknown. EFT/POS terminal did not respond with any results. ',
        Type       : 'warning',
        Icon       : 'mdi-help',
        Color      : 'grey',
        ColorAvatar: 'grey'
      },
      BUSY: {
        Id         : 6,
        Custom     : 'BUSY',
        Code       : 'BUSY',
        Name       : 'BUSY',
        Desc       : 'BUSY',
        Tooltip    : 'Transaction has failed because EFT/POS terminal is not currently available for transactions (either is processing another transaction or is under maintenance).',
        Type       : 'warning',
        Icon       : 'mdi-credit-card-clock-outline',
        Color      : 'blue-grey',
        ColorAvatar: 'blue-grey'
      },
      MAX_TRANSACTIONS: {
        Id         : 7,
        Custom     : 'MAX_TRANSACTIONS',
        Code       : 'MAX_TRANSACTIONS',
        Name       : 'MAX TRANSACTIONS',
        Desc       : 'MAX TRANSACTIONS',
        Tooltip    : 'EFT/POS Terminal has reached its transaction limit for the specific batch. You must first perform batch close on the EFT/POS terminal before sending new transactions.',
        Type       : 'warning',
        Icon       : 'mdi-numeric-off',
        Color      : 'deep-orange',
        ColorAvatar: 'deep-orange'
      },
      JOB_MAX_ATTEMPTS_EXCEEDED: {
        Id         : 0,
        Custom     : 'JOB_MAX_ATTEMPTS_EXCEEDED',
        Code       : 'JOB_MAX_ATTEMPTS_EXCEEDED',
        Name       : 'MAX ATTEMPTS EXCEEDED',
        Desc       : 'MAX ATTEMPTS EXCEEDED',
        Tooltip    : 'The transaction is not executed! It reached the maximum execution tries limit. ',
        Type       : 'warning',
        Icon       : 'mdi-counter',
        Color      : 'orange',
        ColorAvatar: 'orange'
      },
      ERROR: {
        Id         : -1,
        Custom     : 'ERROR',
        Code       : 'ERROR',
        Name       : 'BUSY',
        Desc       : 'BUSY',
        Tooltip    : 'Another request to the terminal is currently being processed, please try again later.',
        Type       : 'error',
        Icon       : 'mdi-credit-card-clock-outline',
        Color      : 'red',
        ColorAvatar: 'red'
      }
    },
    Error: {
      AnotherRequest: 'Another request to the terminal is currently being processed, please try again later.'
    }
  }
}
